module.exports = __webpack_public_path__ + "img/gravier_tuile.ef506ae6.jpg";